export enum StorageSpace {
  AVAILABLE,
  LOW,
  FULL,
}
